(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecz-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-announcement-bar')) {
    customElements.define(
      'ecz-announcement-bar',
      class EczAnnouncementBar extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('.ecz-announce__list');
          const close = this.querySelector('.ecz-announce__close');
          if (close) close.addEventListener('click', () => this.dismiss());
          this.startAutoScroll();
          // Publish the bar height so the sticky header can scroll it away
          this.ro = new ResizeObserver(() => this.publishHeight());
          this.ro.observe(this);
          this.publishHeight();
        }

        publishHeight() {
          const h = this.hidden ? 0 : this.offsetHeight;
          document.documentElement.style.setProperty('--ecz-announce-h', `${h}px`);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          this.ro?.disconnect();
          document.documentElement.style.setProperty('--ecz-announce-h', '0px');
        }

        dismiss() {
          this.hidden = true;
          this.publishHeight();
          clearInterval(this.timer);
        }

        // On narrow screens only one message fits: advance one every few seconds.
        startAutoScroll() {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduce || !this.list || this.list.children.length < 2) return;
          this.timer = setInterval(() => {
            const { scrollLeft, scrollWidth, clientWidth } = this.list;
            if (scrollWidth <= clientWidth + 1) return;
            const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;
            this.list.scrollTo({ left: atEnd ? 0 : scrollLeft + clientWidth, behavior: 'smooth' });
          }, 4000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-case-study-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-slider')) {
    customElements.define(
      'ecz-slider',
      class EczSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-slider-track]');
          this.prev = this.querySelector('[data-slider-prev]');
          this.next = this.querySelector('[data-slider-next]');
          if (!this.track) return;
          this.update = this.update.bind(this);
          this.prev?.addEventListener('click', () => this.go(-1));
          this.next?.addEventListener('click', () => this.go(1));
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
          this.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.go(-1);
            if (event.key === 'ArrowRight') this.go(1);
          });
          this.startAutoplay();
          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          clearInterval(this.timer);
        }

        get slides() {
          return [...this.track.querySelectorAll('[data-slide]')];
        }

        get index() {
          return Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
        }

        goTo(index) {
          const slides = this.slides;
          if (!slides.length) return;
          const target = (index + slides.length) % slides.length;
          this.track.scrollTo({ left: slides[target].offsetLeft, behavior: 'smooth' });
        }

        go(direction) {
          this.stopAutoplay();
          this.goTo(this.index + direction);
        }

        startAutoplay() {
          const seconds = Number(this.dataset.autoplay);
          if (!seconds || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.timer = setInterval(() => {
            if (!this.matches(':hover, :focus-within')) this.goTo(this.index + 1);
          }, seconds * 1000);
        }

        stopAutoplay() {
          clearInterval(this.timer);
        }

        update() {
          const slides = this.slides;
          this.toggleAttribute('data-single', slides.length < 2);
          const index = this.index;
          slides.forEach((slide, i) => {
            slide.setAttribute('aria-label', `${i + 1} / ${slides.length}`);
            slide.inert = i !== index;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-checklist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-checklist')) {
    customElements.define(
      'ecz-checklist',
      class extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('[data-print]');
          if (!button) return;
          button.addEventListener('click', () => {
            document.documentElement.classList.add('ecz-printing');
            this.classList.add('ecz-checklist--print');
            const done = () => {
              document.documentElement.classList.remove('ecz-printing');
              this.classList.remove('ecz-checklist--print');
              window.removeEventListener('afterprint', done);
            };
            window.addEventListener('afterprint', done);
            window.print();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-get-started-form"] && !Shopify.designMode) return;
  try {
    
  class EczStepForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.wrap = this.querySelector('.ecz-gsf__steps');
      if (!this.form || !this.wrap) return;
      this.steps = [...this.wrap.querySelectorAll('[data-step]')];
      this.prevBtn = this.querySelector('[data-action="prev"]');
      this.nextBtn = this.querySelector('[data-action="next"]');
      this.submitBtn = this.querySelector('[data-submit]');
      this.bar = this.querySelector('.ecz-gsf__progress');
      const visible = this.visibleSteps();
      this.current = this.wrap.dataset.start === 'last' ? visible[visible.length - 1] : visible[0];
      this.setAttribute('data-ready', '');

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-action]');
        if (!button) return;
        event.preventDefault();
        if (button.dataset.action === 'next') this.next();
        else this.prev();
      });
      this.form.addEventListener('change', (event) => {
        if (event.target.type === 'radio') {
          const step = event.target.closest('[data-step]');
          step?.querySelector('.ecz-step__error')?.setAttribute('hidden', '');
        }
      });
      this.form.addEventListener('submit', () => {
        const visibleNow = this.visibleSteps();
        this.steps.forEach((step) => {
          const off = !visibleNow.includes(step);
          step.querySelectorAll('input, textarea, select').forEach((field) => (field.disabled = off));
        });
      });
      this.render(false);
    }

    visibleSteps() {
      const keys = new Set(
        [...this.wrap.querySelectorAll('input[type="radio"]:checked')]
          .map((input) => input.dataset.reveals)
          .filter(Boolean)
      );
      return this.steps.filter((step) => !step.dataset.showWhen || keys.has(step.dataset.showWhen));
    }

    isAnswered(step) {
      if (step.dataset.required !== 'true') return true;
      const radios = step.querySelectorAll('input[type="radio"]');
      if (radios.length) return [...radios].some((radio) => radio.checked);
      const text = step.querySelector('textarea');
      return !text || text.value.trim() !== '';
    }

    next() {
      if (!this.isAnswered(this.current)) {
        this.current.querySelector('.ecz-step__error')?.removeAttribute('hidden');
        return;
      }
      const visible = this.visibleSteps();
      const index = visible.indexOf(this.current);
      if (index < visible.length - 1) {
        this.current = visible[index + 1];
        this.render(true);
      }
    }

    prev() {
      const visible = this.visibleSteps();
      const index = visible.indexOf(this.current);
      if (index > 0) {
        this.current = visible[index - 1];
        this.render(true);
      }
    }

    render(focus) {
      const visible = this.visibleSteps();
      const index = Math.max(0, visible.indexOf(this.current));
      const last = index === visible.length - 1;
      this.steps.forEach((step) => (step.hidden = step !== this.current));
      this.prevBtn.hidden = index === 0;
      this.nextBtn.hidden = last;
      this.submitBtn.hidden = !last;
      if (this.bar) {
        const pct = visible.length > 1 ? (index / (visible.length - 1)) * 100 : 0;
        this.bar.style.setProperty('--ecz-progress', `${pct}%`);
      }
      if (focus) {
        const heading = this.current.querySelector('.ecz-step__heading');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
        const top = this.getBoundingClientRect().top;
        if (top < 0) this.scrollIntoView({ block: 'start' });
      }
    }
  }

  if (!customElements.get('ecz-step-form')) customElements.define('ecz-step-form', EczStepForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-header')) {
    customElements.define(
      'ecz-header',
      class EczHeader extends HTMLElement {
        connectedCallback() {
          this.burger = this.querySelector('.ecz-header__burger');
          this.burger?.addEventListener('click', () => this.setOpen(!this.classList.contains('is-open')));

          this.querySelectorAll('.ecz-nav-item__toggle').forEach((toggle) => {
            toggle.addEventListener('click', () => {
              const item = toggle.closest('.ecz-nav-item');
              const open = !item.classList.contains('is-open');
              this.closeItems(item);
              item.classList.toggle('is-open', open);
              toggle.setAttribute('aria-expanded', String(open));
            });
          });

          this.onKey = (event) => {
            if (event.key !== 'Escape') return;
            this.closeItems();
            this.setOpen(false);
          };
          this.onDocClick = (event) => {
            if (!this.contains(event.target)) this.closeItems();
          };
          // Soft shadow once the page has scrolled under the header
          // Horizon scrolls .page-wrapper on desktop and the window on mobile, so read both
          this.onScroll = () => {
            const wrapper = document.querySelector('.page-wrapper');
            const y = Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
            this.classList.toggle('is-stuck', y > 40);
          };
          document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
          this.onScroll();
          document.addEventListener('keydown', this.onKey);
          document.addEventListener('click', this.onDocClick);
        }

        disconnectedCallback() {
          document.removeEventListener('scroll', this.onScroll, { capture: true });
          document.removeEventListener('keydown', this.onKey);
          document.removeEventListener('click', this.onDocClick);
        }

        closeItems(except) {
          this.querySelectorAll('.ecz-nav-item.is-open').forEach((item) => {
            if (item === except) return;
            item.classList.remove('is-open');
            item.querySelector('.ecz-nav-item__toggle')?.setAttribute('aria-expanded', 'false');
          });
        }

        setOpen(open) {
          this.classList.toggle('is-open', open);
          this.burger?.setAttribute('aria-expanded', String(open));
          if (!open) this.closeItems();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-image-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-slider')) {
    class EczSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = this.track ? Array.from(this.track.children) : [];
        this.status = this.querySelector('[data-status]');
        if (this.slides.length < 2) return;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index() - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index() + 1));
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index() - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index() + 1); }
        });
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target.closest('.ecz-image-slider__slide'));
          if (i > -1) this.go(i, false);
        });
      }
      index() {
        const w = this.track.clientWidth || 1;
        return Math.round(this.track.scrollLeft / w);
      }
      go(i, announce = true) {
        const n = this.slides.length;
        const next = ((i % n) + n) % n;
        this.track.scrollTo({ left: next * this.track.clientWidth });
        if (announce && this.status) this.status.textContent = `${next + 1} / ${n}`;
      }
    }
    customElements.define('ecz-slider', EczSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-job-application"] && !Shopify.designMode) return;
  try {
    
  class EczJobForm extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('[data-job-step]')];
      if (!this.steps.length) return;
      this.index = this.querySelector('.ecz-job__errors') ? this.steps.length - 1 : 0;
      this.setAttribute('data-ready', '');
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-job-next]')) this.go(1);
        else if (event.target.closest('[data-job-prev]')) this.go(-1);
      });
      this.addEventListener('input', (event) => {
        const field = event.target;
        if (field.matches('[data-digits]')) field.value = field.value.replace(/[^0-9]/g, '');
        if (field.matches('[data-counter]')) {
          const out = field.parentElement.querySelector('[data-count]');
          if (out) out.textContent = field.value.length;
        }
      });
      this.show(false);
    }

    go(direction) {
      if (direction > 0) {
        const invalid = [...this.steps[this.index].querySelectorAll('input, textarea')].find((f) => !f.checkValidity());
        if (invalid) {
          invalid.reportValidity();
          return;
        }
        this.copyDetails();
      }
      this.index = Math.min(this.steps.length - 1, Math.max(0, this.index + direction));
      this.show(true);
    }

    copyDetails() {
      this.querySelectorAll('[data-copy]').forEach((source) => {
        const target = this.querySelector(`[data-paste="${source.dataset.copy}"]`);
        if (target && !target.value) target.value = source.value;
      });
      const first = this.querySelector('[data-copy="first"]')?.value.trim() || '';
      const greeting = this.querySelector('[data-greeting]');
      if (greeting) greeting.textContent = greeting.dataset.greeting.replace('[name]', first).replace(/\s{2,}/g, ' ').replace(/\s!/, '!');
    }

    show(focus) {
      this.steps.forEach((step, i) => (step.hidden = i !== this.index));
      if (focus) {
        const heading = this.steps[this.index].querySelector('.ecz-job__heading');
        heading?.setAttribute('tabindex', '-1');
        heading?.focus({ preventScroll: true });
        if (this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'start' });
      }
    }
  }

  if (!customElements.get('ecz-job-form')) customElements.define('ecz-job-form', EczJobForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-migrate-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-platform-picker')) {
    customElements.define(
      'ecz-platform-picker',
      class EczPlatformPicker extends HTMLElement {
        connectedCallback() {
          this.submit = this.querySelector('[data-picker-submit]');
          if (!this.submit) return;
          this.submit.addEventListener('click', (event) => {
            const param = this.dataset.param;
            const checked = this.querySelector('input[type="radio"]:checked');
            if (!param || !checked) return;
            const url = new URL(this.submit.href, window.location.origin);
            url.searchParams.set(param, checked.value);
            event.preventDefault();
            window.location.assign(url.toString());
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-migrate-request-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-step-form')) {
    class EczStepForm extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        if (this.steps.length < 2) return;
        this.classList.add('is-enhanced');
        this.start = parseFloat(getComputedStyle(this).getPropertyValue('--ecz-progress-start')) || 0;
        this.show(0, false);
        this.querySelectorAll('[data-next]').forEach((btn) => btn.addEventListener('click', () => this.go(1)));
        this.querySelectorAll('[data-prev]').forEach((btn) => btn.addEventListener('click', () => this.go(-1)));
        // If the server returned errors, open the contact-details step so they can be fixed.
        if (this.querySelector('.ecz-mrf__errors')) this.show(this.steps.length - 1, false);
      }

      go(delta) {
        const next = Math.min(Math.max(this.index + delta, 0), this.steps.length - 1);
        this.show(next, true);
      }

      show(index, focus) {
        this.index = index;
        this.steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
        const span = 100 - this.start;
        const pct = this.steps.length > 1 ? this.start + (span * index) / (this.steps.length - 1) : 100;
        this.style.setProperty('--ecz-progress', `${pct}%`);
        if (focus) {
          const target = this.steps[index].querySelector('input, textarea, button');
          if (target) target.focus();
        }
      }
    }
    customElements.define('ecz-step-form', EczStepForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-pricing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-pricing-toggle')) {
    class EczPricingToggle extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-set-period]'));
        this.buttons.forEach((btn) => {
          btn.addEventListener('click', () => this.set(btn.dataset.setPeriod));
        });
      }
      set(period) {
        this.dataset.period = period;
        this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.setPeriod === period)));
        this.querySelectorAll('[data-monthly]').forEach((el) => {
          el.textContent = el.dataset[period] || el.textContent;
        });
      }
    }
    customElements.define('ecz-pricing-toggle', EczPricingToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-process-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-scroller')) {
    customElements.define(
      'ecz-scroller',
      class EczScroller extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-scroller-track]');
          this.nav = this.querySelector('[data-scroller-nav]');
          this.prev = this.querySelector('[data-scroller-prev]');
          this.next = this.querySelector('[data-scroller-next]');
          if (!this.track || !this.nav) return;
          this.update = this.update.bind(this);
          this.prev?.addEventListener('click', () => this.go(-1));
          this.next?.addEventListener('click', () => this.go(1));
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        go(direction) {
          const item = this.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
          this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
        }

        update() {
          const overflow = this.track.scrollWidth - this.track.clientWidth > 2;
          this.nav.hidden = !overflow;
          if (!overflow) return;
          this.prev.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-stats-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-count-up')) {
    customElements.define(
      'ecz-count-up',
      class EczCountUp extends HTMLElement {
        connectedCallback() {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;
          this.targets = [...this.querySelectorAll('[data-count-to]')];
          this.targets.forEach((el) => (el.textContent = '0'));
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((e) => e.isIntersecting)) return;
              this.observer.disconnect();
              this.run();
            },
            { threshold: 0.3 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.targets?.forEach((el) => (el.textContent = Number(el.dataset.countTo).toLocaleString('en-US')));
        }

        run() {
          const duration = 1600;
          const start = performance.now();
          const step = (now) => {
            const t = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - t, 3);
            this.targets.forEach((el) => {
              el.textContent = Math.round(Number(el.dataset.countTo) * eased).toLocaleString('en-US');
            });
            if (t < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-tab-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-tab-timeline')) {
    class EczTabTimeline extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('mouseenter', () => this.select(i, false));
          tab.addEventListener('keydown', (e) => {
            const map = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: this.tabs.length - 1 };
            if (e.key in map) {
              e.preventDefault();
              const n = (map[e.key] + this.tabs.length) % this.tabs.length;
              this.select(n);
              this.tabs[n].focus();
            }
          });
        });
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.tabs.indexOf(e.target.closest('[role="tab"]'));
          if (i > -1) this.select(i, false);
        });
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls')));
          if (panel) panel.hidden = !on;
        });
      }
    }
    customElements.define('ecz-tab-timeline', EczTabTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-video-hero')) {
    class EczVideoHero extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video[data-src]');
        this.querySelectorAll('[data-scroll-target]').forEach((link) => {
          link.addEventListener('click', (event) => this.scrollTo(event, link));
        });
        if (!this.video) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const saveData = navigator.connection && navigator.connection.saveData;
        if (reduce || saveData) return;
        // Wait for the page (and LCP) to finish before fetching the video at all.
        if (document.readyState === 'complete') this.schedule();
        else window.addEventListener('load', () => this.schedule(), { once: true });
      }

      schedule() {
        const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1200));
        idle(() => {
          if (!('IntersectionObserver' in window)) return this.start();
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.start();
              } else if (this.video.src) {
                this.video.pause();
              }
            });
          });
          this.observer.observe(this);
        });
      }

      start() {
        const video = this.video;
        if (!video.src) {
          video.src = video.dataset.src;
          video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
        }
        const play = video.play();
        if (play && play.catch) play.catch(() => {});
      }

      scrollTo(event, link) {
        const target = document.getElementById(link.dataset.scrollTarget);
        if (!target) return;
        event.preventDefault();
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
    customElements.define('ecz-video-hero', EczVideoHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecz-video-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecz-lazy-video')) {
    /* Loads (and optionally autoplays, muted) the video only when it scrolls into view,
       after the page's load event, so it never competes with LCP. */
    class EczLazyVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.hasAttribute('data-autoplay') && !reduce;
        if (reduce) this.video.controls = true;
        const start = () => {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.activate();
              else if (this.autoplay && !this.video.paused) this.video.pause();
            });
          }, { rootMargin: '200px 0px' });
          this.observer.observe(this);
        };
        if (document.readyState === 'complete') start();
        else window.addEventListener('load', start, { once: true });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      activate() {
        const v = this.video;
        const pending = v.querySelectorAll('source[data-src]');
        if (pending.length) {
          pending.forEach((s) => { s.src = s.dataset.src; s.removeAttribute('data-src'); });
          v.preload = 'metadata';
          v.load();
        }
        if (this.autoplay && v.paused) {
          v.muted = true;
          v.play().catch(() => { v.controls = true; });
        }
      }
    }
    customElements.define('ecz-lazy-video', EczLazyVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
